import { render, staticRenderFns } from "./BgSelector.vue?vue&type=template&id=da92d9f8&scoped=true&"
import script from "./BgSelector.vue?vue&type=script&lang=js&"
export * from "./BgSelector.vue?vue&type=script&lang=js&"
import style0 from "./BgSelector.vue?vue&type=style&index=0&id=da92d9f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da92d9f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
